__webpack_require__.p = "https://bmidxbgroupplpreprod.netlify.app/";